// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../next/Next.bs.js");
let React = require("react");

function Redirect(props) {
  let path = props.path;
  let router = Next.useRouter();
  React.useEffect(() => {
    Next.Router.replace(path, undefined, undefined, router);
  });
  return null;
}

let make = Redirect;

exports.make = make;
/* Next Not a pure module */
